<template>
    <div class="moderation page-container">
        <PageContent
                :content="content"
                scrolling
                img-animation="slideleft"
                txt-animation="slideright"
        >
            <h2>Angaben gem&auml;&szlig; &sect; 5 TMG</h2>
            <p>Dr. Thumm GmbH<br/>
                Elbinger Stra&szlig;e 9<br />
                89231 Neu - Ulm</p>

            <p>Handelsregister: HRB 15771<br />
                Registergericht: Amtsgericht Memmingen</p>

            <p><strong>Vertreten durch die Gesch&auml;ftsf&uuml;hrer:</strong><br />Florian Thumm</p>

            <h2>Kontakt</h2>
            <p>Telefon: +491718647339<br />
                E-Mail: florianthumm@dr-thumm.de</p>

            <h2>Umsatzsteuer-ID</h2>
            <p>Umsatzsteuer-Identifikationsnummer gem&auml;&szlig; &sect;27 a Umsatzsteuergesetz:<br />
                DE 262600678</p>

            <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

            <p>Quelle: <a href="https://www.e-recht24.de">eRecht24</a></p>
            <p>Website entwickelt von <a href="https://toowoxx.de">Toowoxx IT GmbH</a>.</p>
        </PageContent>
    </div>
</template>
<script>
    import impressum from '../content/impressum.json'
    import PageContent from "../components/PageContent";

    export default {
        components: {PageContent},
        metaInfo() {
            return {
                title: this.page.title,
                titleTemplate: "%s | DrThumm GmbH",
                meta: [
                    { name: 'description', content: 'Dr Thumm GmbH' }
                ]
            }
        },
        data() {
            return {
                content: {
                    impressum
                }
            }
        },
        computed: {
            page() {
                this.showImage = false
                let route = this.$route.fullPath
                let routes = route.split('/')
                var filtered = routes.filter(el => el != "" )

                let content = this.content
                console.log(content.moderation)
                filtered.forEach(r => {
                    if (filtered.length === 1) content = content[r][r]
                    else content = content[r]
                })

                return content
            }

        },
        beforeCreate() {
            document.body.className = ""
        }
    }
</script>
<style lang="sass">

</style>